const PHASE_NAMES = {
  CUSTOMER: "Customer Information",
  RELATIONS: "Customer Relations",
  UNITS: "Unit Information",
  BUILD: "Build",
  PRICING: "Pricing",
  PAYMENT: "Payment",
  QUOTE_PRICING: "Quote Pricing",
};
const CONTRACT_PHASE_LIST = [
  PHASE_NAMES.CUSTOMER,
  PHASE_NAMES.RELATIONS,
  PHASE_NAMES.UNITS,
  PHASE_NAMES.PRICING,
  PHASE_NAMES.PAYMENT,
];
const CONTRACT_BUILD_PHASE_LIST = [
  PHASE_NAMES.CUSTOMER,
  PHASE_NAMES.RELATIONS,
  PHASE_NAMES.UNITS,
  PHASE_NAMES.BUILD,
  PHASE_NAMES.PRICING,
  PHASE_NAMES.PAYMENT,
];
const CASH_SALE_PHASE_LIST = [
  PHASE_NAMES.CUSTOMER,
  PHASE_NAMES.UNITS,
  PHASE_NAMES.PAYMENT,
];
const CASH_SALE_BUILD_PHASE_LIST = [
  PHASE_NAMES.CUSTOMER,
  PHASE_NAMES.UNITS,
  PHASE_NAMES.BUILD,
  PHASE_NAMES.PAYMENT,
];
const QUOTE_PHASE_LIST = [
  PHASE_NAMES.CUSTOMER,
  PHASE_NAMES.UNITS,
  //PHASE_NAMES.QUOTE_PRICING,
];

export default {
	PHASE_NAMES,
	CONTRACT_PHASE_LIST,
	CONTRACT_BUILD_PHASE_LIST,
	CASH_SALE_PHASE_LIST,
	CASH_SALE_BUILD_PHASE_LIST,
	QUOTE_PHASE_LIST
};